
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './pages/admin/Dashboard';
import AdminUsers from './pages/admin/Users';
import AdminApplications from './pages/admin/Applications';
import AdminQuoteManagementPage from './pages/admin/QuoteManagement';
import PEOVerifications from './pages/admin/PEOVerifications';
import PEOManagementPage from './pages/admin/PEOManagement';
import AdminClients from './pages/admin/Clients';
import RestrictedAccess from './pages/peo/RestrictedAccess';
import Dashboard from './pages/Dashboard';
import Index from './pages/Index';
import NotFound from './pages/NotFound';
import PEODashboard from './pages/peo/Dashboard';
import Application from './pages/Application';
import ApplicationSubmitted from './pages/ApplicationSubmitted';
import QuotePage from './pages/Quotes';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        
        {/* Protected routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Quotes page */}
        <Route 
          path="/quotes" 
          element={
            <ProtectedRoute>
              <QuotePage />
            </ProtectedRoute>
          } 
        />
        
        {/* Application routes */}
        <Route 
          path="/application" 
          element={
            <ProtectedRoute>
              <Application />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/application/submitted" 
          element={
            <ProtectedRoute>
              <ApplicationSubmitted />
            </ProtectedRoute>
          } 
        />
        
        {/* Admin routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/applications"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <AdminApplications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/quotes"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <AdminQuoteManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/verifications"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <PEOVerifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/peo"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <PEOManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/clients"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <AdminClients />
            </ProtectedRoute>
          }
        />
        
        {/* PEO provider routes */}
        <Route 
          path="/peo/restricted" 
          element={
            <ProtectedRoute requiredRole="peo">
              <RestrictedAccess />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/peo/dashboard" 
          element={
            <ProtectedRoute requiredRole="peo">
              <PEODashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Catch-all for 404 errors */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
